import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { EXCHANGE_CARD_ICON } from '../../config/media';
import { ExchangeList } from './style';

class Exchange extends Component {
	renderExchangeList = () => {
		return this.props.data.map((item, index) => {
			const imgIndex = (item.id % 6) + 1;
			return (
				<Link to={'/exchange?id=' + item.id} key={`exchange-${index}`}>
					<img
						src={EXCHANGE_CARD_ICON[imgIndex]}
						alt="LOGO_HOLLAEX"
						className="info-logo"
					/>
				</Link>
			);
		});
	};

	render() {
		if (this.props.data.length < 1) return null;
		const link = {
			pathname: '/exchange/new',
			state: {
				isNew: true
			}
		};
		return (
			<ExchangeList>
				{this.renderExchangeList()}
				<Link to={link} className="new-exchange">
					+
				</Link>
			</ExchangeList>
		);
	}
}

export default Exchange;
